import React, { useEffect, useState } from 'react';
import Decode from 'jwt-decode';

// IMPORT DEPENDENCIES
import { Link, Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { kuryeParasiService, updateKuryeParasiCancel } from '../../actions/admin/admin';

//IMPORT COMPONENT
import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';
import Loader from '../../components/loader/loader';

const KuryePara = () => {

    const Dispatch = useDispatch();



    const token = useSelector(state => state.AuthReducer.token);
    const kuryepara = useSelector(state => state.AdminReducer.kuryepara);
    const kuryeparasidata = useSelector(state => state.AdminReducer.kuryeparasidata);
    const loading = useSelector(state => state.AdminReducer.loading);


    var decoded = Decode(token)

    useEffect(() => {
        Dispatch(updateKuryeParasiCancel());
    }, []);


    const [cuzdan, setCuzdan] = useState(kuryeparasidata.cuzdan);
    const [error, setError] = useState(false);
    const [para, setPara] = useState('')


    const handlePara = (e) => {
        setPara(e.target.value)
        console.log(e.target.value)
        setError(false);
    }


    const handleEkle = (e) => {
        e.preventDefault();
        console.log(para)
        if (Number(para) !== 0 && Number(para) !== undefined) {
            let Total = ( Number(cuzdan) +Number(para)).toFixed(2)
            console.log(Total)
            if (Number(Total) < 0) {
                setError(true)
            }
            else {
                Dispatch(kuryeParasiService(Total.toString(), kuryeparasidata.id, token));
            }

        }
        else {
            setError(true);
        }
    }

    const handleKes = (e) => {
        e.preventDefault();
        if (Number(para) !== 0 && Number(para) !== undefined) {
            let Total = ( Number(cuzdan) - Number(para)).toFixed(2)
            console.log(Total)
            if (Number(Total) < 0) {
                setError(true)
            }
            else {
                Dispatch(kuryeParasiService(Total.toString(), kuryeparasidata.id, token));
            }

        }
        else {
            setError(true);
        }
    }


    let PageRedirect = null
    if (kuryepara) {
        PageRedirect = <Redirect to="/kurye-listesi" />
    }

    return (
        <div>
            <Header />
            <div class="wrapper">
                <div class="container-fluid">
                    {PageRedirect}
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <div class="page-title-right">
                                    <ol class="breadcrumb m-0">
                                        <li class="breadcrumb-item"><a href="javascript: void(0);">Aninda Bi'Kurye</a></li>
                                        <li class="breadcrumb-item"><a href="javascript: void(0);"> Kurye Parasi</a></li>
                                        <li class="breadcrumb-item active"> Ekle - Kes</li>
                                    </ol>
                                </div>
                                <h4 class="page-title"></h4>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="card-box">
                                <h4 class="m-t-0 header-title"> Kurye Parasi</h4>
                                <p class="text-muted mb-4 font-14">
                                </p>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="p-2">
                                            <form class="form-horizontal" role="form">
                                                <div class="form-group row">
                                                    <label class="col-sm-2  col-form-label" for="simpleinput">Cuzdan (TL)</label>
                                                    <div class="col-sm-10">
                                                        <input type="text" id="simpleinput" disabled value={cuzdan} class="form-control" placeholder='Kurye Cuzdan' />
                                                    </div>
                                                </div>

                                                <div class="form-group row">
                                                    <label class="col-sm-2  col-form-label" for="simpleinput">Para Yaz (TL)</label>
                                                    <div class="col-sm-10">
                                                        <input type="number" id="simpleinput" value={para} class="form-control" onChange={handlePara} placeholder="Para yaz" />
                                                    </div>
                                                </div>

                                                {
                                                    error ?
                                                        <div class="form-group row">
                                                            <label class="col-sm-2  col-form-label" for="simpleinput"></label>
                                                            <div class="col-sm-10">
                                                                <p style={{ color: 'red' }}>Bilgilerinizi kontrol edin lütfen!</p>
                                                            </div>
                                                        </div>
                                                        :
                                                        null
                                                }
                                                <div class="form-group row">
                                                    <label class="col-sm-2  col-form-label" for="simpleinput"></label>
                                                    {loading ? <div class="col-sm-10">
                                                        <Loader />
                                                    </div>
                                                        :
                                                        <div class="col-sm-10">
                                                            <button onClick={handleEkle} class="btn btn-success">Ekle</button>
                                                            <button onClick={handleKes} class="btn btn-danger" style={{ marginLeft: 10, color: 'white' }}>Kes</button>
                                                        </div>
                                                    }
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
};

export default KuryePara